import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent, GroupBox } from 'core/components';
import { withLocale } from 'core/decorators';
import { Row, Col, Icon, Button, CardContent, CardFooter, Segmented, Radio } from 'core/components/Framework7';
import { deleteAddress } from 'core/module/operations';

import classes from './styles.module.css';

class AddressList extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  get initialValue() {
    return this.parseAddress()
  }

  parseAddress() {
    const { item } = this.props;

    // console.log(this.props);
    // console.log("props");
    return {
      id: item ? item.id : null,
      addressTitle: item ? item.address ? item.address.title : null : null,
      address: item ? item.address ? item.address.text : null : null
    }
  }

  deleteAddress(item) {
    this.$f7.dialog.confirm("آیا از حذف آدرس اطمینان دارید؟", "حذف آدرس", () => this.deleteItem(item), this.$f7.dialog.close())
  }

  deleteItem(item) {
    const id = item.id;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const params = {
      store: 2
    }

    this.props.deleteAddress(id, params)
      .finally(r => { this.$f7.dialog.close() });
  }

  render() {
    const item = this.initialValue;
    const { radio, name, value, checked } = this.props

    return (
      <GroupBox outline key={item.id}>
        <CardContent>
          <Col width="85">
            <p className={classes.addressTitle}>{item.addressTitle}</p>
            <p className={classes.address}>{item.address}</p>
          </Col>
        </CardContent>
        <CardFooter>
          <Row>
            <Col width="10">
              {radio &&
                <Radio
                  name={name}
                  value={value}
                  checked={checked}
                  onChange={this.props.onChange}
                />
              }
            </Col>
            <Col width="50" />
            <Col width="40">
              <Segmented tag="div">
                <Button outline className={classes.button} onClick={() => this.deleteAddress(item)}>
                  <Icon icon="mdi-delete" />
                </Button>
                <Button outline className={classes.button} href={`/address/${item.id}`}>
                  <Icon icon="mdi-pencil" />
                </Button>
              </Segmented>
            </Col>
          </Row>
        </CardFooter>
      </GroupBox>
    )
  }
}

export default connect(
  state => ({

  }),
  {
    deleteAddress
  }
)(withLocale('home')(autobind(AddressList)))
